import * as React from 'react';
export const ArrowRight = (props) => (React.createElement("svg", { width: "30", height: "23", viewBox: "0 0 30 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M0.449219 11.5H28.5573M28.5573 11.5L19.3112 0.959473M28.5573 11.5L19.3112 22.0406", stroke: "currentColor", strokeWidth: "1.5" })));
